var map = {
	"./cursive-workbook_B0992G14VV.jpg": "c472",
	"./graph-paper-notebook_B099NJT3NR.jpg": "effd",
	"./scientific-notebook_B09HG6HWB5.jpg": "2437"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3607";